var map = {
	"./404.png": 2359,
	"./Group 3571.png": 8418,
	"./NotFound.png": 2517,
	"./a2z.svg": 8735,
	"./download.png": 2177,
	"./hr_logo.svg": 8056,
	"./logout.svg": 6301,
	"./pdf.png": 7874,
	"./settings.svg": 5812,
	"./z2a.svg": 9410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;